import { request, tinyService } from '@/utils/newrequest'

// 为配合后台微服务修改，现不能动以前代码的请求接口所以进行判断是否是新接口的请求地址
// 针对需要携带参数的请求getaxiosdata，PostData进行配置，若为type为true则为请求微服务

// 判断字符串
export function Judge(url) {
  const uel_list = '/admin/'
  if (url.includes(uel_list)) {
    return url
  } else if (url.includes('/mediate/')) {
    return url
  } else {
    const index = url.indexOf('/plaintiff/')
    if (index == -1 || index !== 0) {
      if (url.substr(0, 1) === '/') {
        return `/plaintiff${url}`
      } else {
        return `/plaintiff/${url}`
      }
    } else {
      return url
    }
  }
}
export function fetchList(url, data) {
  return request({
    url: Judge(url),
    method: 'post',
    data
  })
}
export function getaxios(url) {
  return request({
    url: Judge(url),
    method: 'get'
  })
}
export function getaxiosdata(url, query) {
  if (url.type) {
    return tinyService({
      url: Judge(url.url),
      method: 'get',
      params: query
    })
  } else {
    return request({
      url: Judge(url),
      method: 'get',
      params: query
    })
  }
}
export function deleteaxios(url) {
  return request({
    url: url,
    method: 'delete'
  })
}
export function PostData(url, data) {
  if (url.type) {
    return tinyService({
      url: Judge(url.url),
      method: 'post',
      data
    })
  } else {
    return request({
      url: Judge(url),
      method: 'post',
      data
    })
  }
}
export function PostPut(url, data, urlobj) {
  if (urlobj) {
    url = Judge(`${url}/${urlobj}`)
  }
  return request({
    headers: { 'Content-Type': 'application/json', 'X-HTTP-Method-Override': 'PUT' },
    url: url,
    method: 'post',
    data
  })
}

export function updateArticle(url, data) {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    url: url,
    method: 'post',
    data
  })
}
